import { HttpService } from "./../http-service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import "rxjs/add/operator/toPromise";

import { Contrato } from "./../../domain/contrato";
import { LoggerService } from "../providers";

@Injectable()
export class ContratoProvider {
  public contrato: Contrato;
  private _url: string = "/contratos";

  constructor(public http: HttpService, public loggerService: LoggerService) {}

  public save = (contrato: Contrato) => {
    return new Promise((success, reject) => {
      let action;
      let _success = success;
      let _reject = reject;
      let _erroMsg = this._manageMessage;

      if (contrato.id !== undefined && contrato.id > 0) {
        action = this.http.put(
          this._url,
          JSON.stringify(contrato),
          contrato.id
        );
      } else {
        action = this.http.post(this._url, null, JSON.stringify(contrato));
      }

      action
        .map((res) => res.json().data)
        .toPromise()
        .then(function (data) {
          _success(data);
        })
        .catch((err) => {
          this.loggerService.error(
            err,
            "Erro na requisição para salvar o contrato"
          );
          _reject(_erroMsg(err));
        });
    });
  };

  public search(term: string): Observable<any> {
    let data: Observable<any> = this.http.get(this._url + "/search/" + term);
    return data;
  }

  public searchExcludingType(term: string, excludeType: number): Observable<any> {
    return this.http.get(this._url + "/search/" + term + "?exclude_type=" + excludeType);
  }

  public getById(id: number): Observable<any> {
    return this.http
      .get(this._url + "/" + id)
      .map((res) => {
        return res.json().data;
      })
      .catch(this._manageMessage);
  }

  /** Privates  */

  private _manageMessage(retorno) {
    try {
      let msgs = JSON.parse(retorno._body);
      let r = " Atenção aos campos: ";
      if (msgs.error === true && msgs.message) {
        r = msgs.message;
      } else {
        for (var key in msgs) {
          if (msgs.hasOwnProperty(key)) {
            r += key + ", ";
          }
        }
      }

      return r;
    } catch (error) {
      return "Não foi possível realizar a operação solicitada";
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/contrato/contrato.provider.ts